import { useModalsClose } from "@/shared/hooks"

export const ModalsContainer = () => {
  useModalsClose()

  return <></>
}
